module.exports = __webpack_public_path__ + "static/media/dubleBg3.1dc88983.png";